import { PlacementSource } from '@zg-rentals/ts-rental-manager-api-client';

export type CountDeltas = {
  pinnedDelta: number;
  autoDelta: number;
};

/**
 * Pure function to calculate count deltas based on action and current state
 */
export const calculateCountDeltas = (
  action: 'pin' | 'unpin' | 'exclude' | 'unexclude',
  currentSource: PlacementSource | null | undefined,
): CountDeltas => {
  const wasAuto = currentSource === PlacementSource.AUTO;
  const wasPinned = currentSource === PlacementSource.PINNED;

  switch (action) {
    case 'pin':
      return { pinnedDelta: 1, autoDelta: wasAuto ? -1 : 0 };
    case 'unpin':
      return { pinnedDelta: -1, autoDelta: 1 };
    case 'exclude':
      return { pinnedDelta: wasPinned ? -1 : 0, autoDelta: wasAuto ? -1 : 0 };
    case 'unexclude':
      return { pinnedDelta: 0, autoDelta: 1 };
  }
};

/**
 * Pure function to apply deltas to counts
 */
export const applyCountDeltas = (
  counts: { pinnedCount: number; autoCount: number; availableCount: number },
  deltas: CountDeltas,
): { pinnedCount: number; autoCount: number; availableCount: number } => {
  return {
    pinnedCount: Math.max(0, counts.pinnedCount + deltas.pinnedDelta),
    autoCount: Math.max(0, counts.autoCount + deltas.autoDelta),
    availableCount: Math.max(0, counts.availableCount - deltas.pinnedDelta - deltas.autoDelta),
  };
};

/**
 * Pure function to invert deltas for rollback
 */
export const invertDeltas = (deltas: CountDeltas): CountDeltas => ({
  pinnedDelta: -deltas.pinnedDelta,
  autoDelta: -deltas.autoDelta,
});
